import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=c2dbea14"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=c2dbea14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports